import { getApi, postApi, putApi, deleteApi } from "./_apihelper";

export const AddClients = (data) =>
  postApi(
    process.env.REACT_APP_ALL_CLIENTS,
    data,
    process.env.REACT_APP_CLIENTS,
  );

export const EditClients = (id, data) =>
  putApi(
    `${process.env.REACT_APP_ALL_CLIENTS}/${id}`,
    data,
    process.env.REACT_APP_CLIENTS,
  );

export const GetClients = (id) => {
  let url = `${process.env.REACT_APP_ALL_CLIENTS}/${id}`;
  return getApi(url, process.env.REACT_APP_CLIENTS);
};

export const DeleteClients = (data) =>
  deleteApi(
    process.env.REACT_APP_ALL_CLIENTS,
    data,
    process.env.REACT_APP_CLIENTS,
  );

export const ParentClients = (data) =>
  getApi(process.env.REACT_APP_ALL_CLIENTS, process.env.REACT_APP_CLIENTS);

export const FilterClients = (keword) =>
  getApi(
    `${process.env.REACT_APP_ALL_CLIENTS}?keyword=${encodeURIComponent(keword)}`,
    process.env.REACT_APP_CLIENTS,
  );

export const GetClientswithPaging = (limit, offset, status) => {
  if (status && status !== "In negotiation") {
    return getApi(
      `${process.env.REACT_APP_ALL_CLIENTS}?limit=${limit}&offset=${offset}&isactive=${status}`,
      process.env.REACT_APP_CLIENTS,
    );
  } else if (status && status === "In negotiation") {
    return getApi(
      `${process.env.REACT_APP_ALL_CLIENTS}?limit=${limit}&offset=${offset}&pilot=${status}`,
      process.env.REACT_APP_CLIENTS,
    );
  } else {
    return getApi(
      `${process.env.REACT_APP_ALL_CLIENTS}?limit=${limit}&offset=${offset}`,
      process.env.REACT_APP_CLIENTS,
    );
  }
};

export const GetClientswithFields = (field) =>
  getApi(
    `${process.env.REACT_APP_ALL_CLIENTS}?filterBy=${field}`,
    process.env.REACT_APP_CLIENTS,
  );

export const FilterClientsWithPaging = (limit, offset, filterValue) =>
  getApi(
    `${process.env.REACT_APP_ALL_CLIENTS}?limit=${limit}&offset=${offset}&keyword=${encodeURIComponent(filterValue)}`,
    process.env.REACT_APP_CLIENTS,
  );

export const GetClientsComments = (data) =>
  getApi(
    `${process.env.REACT_APP_CLIENTS_COMMENTS}?type=${data.type}&typeId=${data.typeId}`,
    process.env.REACT_APP_CLIENTS,
  );

export const GetClientJobs = (id, obj, filterValue) => {
  if (filterValue && filterValue !== "All") {
    return getApi(
      `${process.env.REACT_APP_ALL_CLIENTS}/${id}/clientJobs?limit=${obj.limit}&offset=${obj.offset}&endClientId=${filterValue}`,
      process.env.REACT_APP_CLIENTS,
    );
  } else {
    return getApi(
      `${process.env.REACT_APP_ALL_CLIENTS}/${id}/clientJobs?limit=${obj.limit}&offset=${obj.offset}`,
      process.env.REACT_APP_CLIENTS,
    );
  }
};

export const AddHiringManagers = (id, data) =>
  postApi(
    `${process.env.REACT_APP_ALL_CLIENTS}/${id}/hiringmanagers`,
    data,
    process.env.REACT_APP_CLIENTS,
  );

export const GetHiringManagers = (id, query) =>
  getApi(
    `${process.env.REACT_APP_ALL_CLIENTS}/${id}/hiringmanagers?limit=${query.limit}&offset=${query.offset}&keyword=${query.keyword}`,
    process.env.REACT_APP_CLIENTS,
  );

export const EditHiringManagers = (id, data, managerId) =>
  putApi(
    `${process.env.REACT_APP_ALL_CLIENTS}/${id}/hiringmanagers/${managerId}`,
    data,
    process.env.REACT_APP_CLIENTS,
  );

export const DeleteHiringManagers = (id, data) =>
  deleteApi(
    `${process.env.REACT_APP_ALL_CLIENTS}/${id}/hiringmanagers`,
    data,
    process.env.REACT_APP_CLIENTS,
  );

export const AddEndClients = (id, data) =>
  postApi(
    `${process.env.REACT_APP_ALL_CLIENTS}/${id}/endclient`,
    data,
    process.env.REACT_APP_CLIENTS,
  );

export const GetEndClients = (id, query) => {
  if (query) {
    return getApi(
      `${process.env.REACT_APP_ALL_CLIENTS}/${id}/endclients?limit=${query.limit}&offset=${query.offset}`,
      process.env.REACT_APP_CLIENTS,
    );
  } else {
    return getApi(
      `${process.env.REACT_APP_ALL_CLIENTS}/${id}/endclients`,
      process.env.REACT_APP_CLIENTS,
    );
  }
};

export const EditEndClients = (id, data, endClientId) =>
  putApi(
    `${process.env.REACT_APP_ALL_CLIENTS}/${id}/endclient/${endClientId}`,
    data,
    process.env.REACT_APP_CLIENTS,
  );

export const DeleteEndClients = (id, data) =>
  deleteApi(
    `${process.env.REACT_APP_ALL_CLIENTS}/${id}/endusers`,
    data,
    process.env.REACT_APP_CLIENTS,
  );
